import { render, staticRenderFns } from "./BenefitHubBanner.vue?vue&type=template&id=47d1d997"
import script from "./BenefitHubBanner.vue?vue&type=script&lang=js"
export * from "./BenefitHubBanner.vue?vue&type=script&lang=js"
import style0 from "./BenefitHubBanner.vue?vue&type=style&index=0&id=47d1d997&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports